"use client"

import PropTypes from "prop-types";

const Button = ({ title, onClick, type = "button", className = "" }) => {
  return (
    <button
    type={type}
    onClick={onClick}
    className={`flex justify-center items-center px-4 py-3 gap-2 w-auto h-auto text-white bg-[#E56717] rounded-[4px]
   ${className}`}
  >
    {title}
  </button>
  );
};

Button.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired, 
  type: PropTypes.string,
  className: PropTypes.string,
};

export default Button;
